module.exports = __webpack_public_path__ + "img/square-orange.7a3c63c8.svg";